import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2uh94q39qp: FaireBrandEntity = {
  token: "b_2uh94q39qp",
  type: "brand",
  name: "Z Bars Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/4ec7e2a43b11ed621f01fc90e49f525959266f6759b6f0b68d36760753e9e712.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e23ee6656d435f190694f114cb4d1feb2f00957e148f9fc18505ed38eef79e8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4ec7e2a43b11ed621f01fc90e49f525959266f6759b6f0b68d36760753e9e712.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e23ee6656d435f190694f114cb4d1feb2f00957e148f9fc18505ed38eef79e8.jpeg",
  location: "Healdton, OK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 51,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi, my name is Madison Stump but I go by Maddie Rae! I’ve dreamed of designing and making jewelry since I was a little girl. Starting this business has helped me to fulfill my one of my lifelong dreams. My family has a vast history of southwestern and cowboy culture which is what inspired my love southwest jewelry. These frequent trips to the Land of Enchantment helped development my appreciation of their culture. I have combined my cultural experiences and past knowledge from dealing in Native American and Artisan made jewels to create this unique brand to express my creative side. My jewelry is all handmade by myself and small team of like-minded women in a small town in Southern Oklahoma. All of my stones and beads used in my pieces are genuine semiprecious gemstones. The metals used in these pieces include; sterling silver, high quality sterling silver chains, and the occasional use of copper or 14k gold filled chains and beads. ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:45.643Z",
    importedBy: "entity-db-cli",
  },
};
